var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-bar',[_c('router-link',{attrs:{"to":{name: 'project-create'}}},[_vm._v("Neues Projekt erstellen")])],1),_vm._v(" "),_c('main',{staticClass:"content"},[_c('h1',[_vm._v("Projekte")]),_vm._v(" "),(_vm.projects)?_c('project-list',{attrs:{"projects":_vm.projects,"type":"normal"}}):_c('loading')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85b0e900","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/project/List.vue
// module id = null
// module chunks = 